import { render, staticRenderFns } from "./TransferNakladnoy.vue?vue&type=template&id=77dbf7c2&scoped=true"
import script from "./TransferNakladnoy.vue?vue&type=script&lang=js"
export * from "./TransferNakladnoy.vue?vue&type=script&lang=js"
import style1 from "./TransferNakladnoy.vue?vue&type=style&index=1&id=77dbf7c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dbf7c2",
  null
  
)

export default component.exports